// extracted by mini-css-extract-plugin
export var iconContainer = "styles-module--icon-container--66dfe";
export var iconContainer__icon = "styles-module--icon-container__icon--b1d2d";
export var iconContainer__text = "styles-module--icon-container__text--909c5";